enum SubmenuType {
  LANGUAGE_PICKER = 'LANGUAGE_PICKER',
  DISPLAY_SETTINGS = 'DISPLAY_SETTINGS',
  RELEASES = 'RELEASES',
}

export default SubmenuType;
